import {useQuery} from '@tanstack/react-query';
import {authApi} from '../api';

export function localPhone(value:string|null|undefined,callingCode?:string,length?:number){
 if(!value)return 'Phone not provided';
 const digits=value.replace(/[\s()+-]/g,'');
 if(!callingCode||!length)return value;
 if(digits.length===callingCode.length+length&&digits.startsWith(callingCode))return digits.slice(callingCode.length);
 if(digits.length===length+1&&digits.startsWith('0'))return digits.slice(1);
 return digits;
}
/** National display only; stored numbers and API payloads are unchanged. */
export function LocalPhone({value}:{value:string|null|undefined}){
 const countries=useQuery({queryKey:['countries'],queryFn:()=>authApi.countries(),staleTime:Infinity});
 const digits=value?.replace(/[\s()+-]/g,'')??'';
 const country=countries.data?.find(c=>digits.startsWith(c.callingCode)&&digits.length===c.callingCode.length+c.nationalNumberLength);
 return <>{localPhone(value,country?.callingCode,country?.nationalNumberLength)}</>;
}
